// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__3JeEV","choiceBoxes":"toolbarselects_choiceBoxes__2_MwQ","simpleField":"toolbarselects_simpleField__2IOdA"};